import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";


const IconDownFile = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Outlined/document-download">
          <g id="icon">
            <path
              d="M7.50008 14.7917C7.41675 14.7917 7.34175 14.775 7.25842 14.7417C7.02508 14.65 6.87508 14.4167 6.87508 14.1667V9.16667C6.87508 8.82501 7.15841 8.54167 7.50008 8.54167C7.84175 8.54167 8.12508 8.82501 8.12508 9.16667V12.6583L8.72508 12.0583C8.96675 11.8167 9.36675 11.8167 9.60841 12.0583C9.85008 12.3 9.85008 12.7 9.60841 12.9417L7.94175 14.6083C7.82508 14.725 7.65841 14.7917 7.50008 14.7917Z"
              fill={color}
            />
            <path
              d="M7.50008 14.7917C7.34175 14.7917 7.18342 14.7333 7.05842 14.6083L5.39175 12.9417C5.15008 12.7 5.15008 12.3 5.39175 12.0583C5.63341 11.8167 6.03341 11.8167 6.27508 12.0583L7.94175 13.725C8.18341 13.9667 8.18341 14.3667 7.94175 14.6083C7.81675 14.7333 7.65841 14.7917 7.50008 14.7917Z"
              fill={color}
            />
            <path
              d="M12.5001 18.9583H7.50008C2.97508 18.9583 1.04175 17.025 1.04175 12.5V7.50001C1.04175 2.97501 2.97508 1.04167 7.50008 1.04167H11.6667C12.0084 1.04167 12.2917 1.32501 12.2917 1.66667C12.2917 2.00834 12.0084 2.29167 11.6667 2.29167H7.50008C3.65841 2.29167 2.29175 3.65834 2.29175 7.50001V12.5C2.29175 16.3417 3.65841 17.7083 7.50008 17.7083H12.5001C16.3417 17.7083 17.7084 16.3417 17.7084 12.5V8.33334C17.7084 7.99167 17.9917 7.70834 18.3334 7.70834C18.6751 7.70834 18.9584 7.99167 18.9584 8.33334V12.5C18.9584 17.025 17.0251 18.9583 12.5001 18.9583Z"
              fill={color}
            />
            <path
              d="M18.3334 8.95834H15.0001C12.1501 8.95834 11.0417 7.85001 11.0417 5.00001V1.66667C11.0417 1.41667 11.1917 1.18334 11.4251 1.09167C11.6584 0.991672 11.9251 1.05001 12.1084 1.22501L18.7751 7.89167C18.9501 8.06667 19.0084 8.34167 18.9084 8.57501C18.8084 8.80834 18.5834 8.95834 18.3334 8.95834ZM12.2917 3.17501V5.00001C12.2917 7.15001 12.8501 7.70834 15.0001 7.70834H16.8251L12.2917 3.17501Z"
              fill={color}
            />
          </g>
        </g>
      </svg>
    </SvgWrapper>
  );
};

export default IconDownFile;
